import { RootState } from 'app/store';

export const selectPeriods = (state: RootState) => state.periods.periods;
export const selectIsLoadingPeriod = (state: RootState) =>
  state.periods.isLoadingPeriods;
